<template>
  <div class="app-container">
    <mu-tabs class="tabs-box" :value.sync="active" :indicator-color="themeConfig.dark" :color="themeConfig.dark" :text-color="themeConfig.dark" inverse center>
      <mu-tab class="tabs-item">最新消息</mu-tab>
      <mu-tab class="tabs-item">历史公告</mu-tab>
    </mu-tabs>
    <div class="item-box" ref="ib" :style="`height: ${IBHeight}px;`" v-loading="loading">
      <mu-fade-transition>
        <div class="item" v-if="active === 0">
          <div class="img-box" v-if="!content && !loading">
            <img :src="require(`@/assets/img/${theme[init.ui_type].imgUrl}/Syg_icon_sdfdssd.png`)">
          </div>
          <div class="cont" v-else>
            <p class="title">{{title}}</p>
            <p class="time">{{created_at}}</p>
            <div class="content" v-html="content"></div>
          </div>
        </div>
      </mu-fade-transition>
      <mu-fade-transition>
        <div class="item" v-if="active === 1">
          <div class="img-box" v-if="noticeList.length === 0 && !loading">
            <img :src="require(`@/assets/img/${theme[init.ui_type].imgUrl}/Syg_icon_sdfdssd.png`)">
          </div>
          <mu-list>
            <mu-list-item button v-for="(item, index) in noticeList" :key="index" @click="getContent(item)">
              <mu-list-item-title>{{item.title}}</mu-list-item-title>
              <mu-list-item-action>
                {{item.created_at}}
              </mu-list-item-action>
            </mu-list-item>
          </mu-list>
        </div>
      </mu-fade-transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { announcementList } from '@/api/announcementList'
import { newPromise } from '@/utils'
export default {
  name: 'Notice',
  data () {
    return {
      loading: false,
      active: 0,
      IBHeight: 0,
      list: [],
      title: '',
      created_at: '',
      content: ''
    }
  },
  computed: {
    ...mapGetters([
      'themeConfig',
      'theme',
      'init',
      'noticeList',
      'noticeStatus'
    ])
  },
  mounted () {
    if (this.$refs.ib.offsetTop > window.innerHeight) {
      this.IBHeight = 300
    } else {
      this.IBHeight = window.innerHeight - this.$refs.ib.offsetTop
    }
    if (!this.noticeStatus) {
      this.announcementList()
    } else {
      if (this.noticeList.length > 0) {
        [this.title, this.created_at, this.content] = [this.noticeList[0].title, this.noticeList[0].created_at, decodeURIComponent(this.noticeList[0].content.replace(/\+/g, '%20'))]
      }
    }
    this.$nextTick(() => {
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          if (this.$refs.ib) {
            if (this.$refs.ib.offsetTop > window.innerHeight) {
              this.IBHeight = 300
            } else {
              this.IBHeight = window.innerHeight - this.$refs.ib.offsetTop
            }
          }
        }, 350)
      })
    })
  },
  methods: {
    async announcementList () {
      this.loading = true
      const res = await newPromise(announcementList)
      this.loading = false
      if (res.error_code) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      } else {
        this.$store.commit('SET_NOTICELIST', res.data)
        this.$store.commit('SET_NOTICESTATUS', true)
        if (res.data.length) {
          [this.title, this.created_at, this.content] = [res.data[0].title, res.data[0].created_at, decodeURIComponent(res.data[0].content.replace(/\+/g, '%20'))]
        }
      }
    },
    getContent (item) {
      [this.title, this.created_at, this.content] = [item.title, item.created_at, decodeURIComponent(item.content.replace(/\+/g, '%20'))]
      this.active = 0
    }
  }
}
</script>

<style lang="less" scoped>
.item-box {
  position: relative;
  overflow-y: scroll;
  .item {
    padding: .3rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .mu-item-title {
      font-size: .16rem;
    }
    .mu-item-action {
      font-size: .12rem;
      min-width: 130px;
    }
  }
}
.mu-list {
  padding-top: 0;
}
.title {
  font-size: 14px;
  color: #333;
  text-align: center;
}
.time {
  font-size: 12px;
  color: #999;
  text-align: center;
  line-height: 20px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}
.img-box {
  width: 2rem;
  margin: .2rem auto;
  img {
    display: block;
    width: 100%;
  }
}
</style>
